import styled from "@emotion/styled";
import React, { ReactNode } from 'react';
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from"react-icons/io"

type RadioButtonProps = {
  name:string;
  value:string;
  onChange : (event: React.ChangeEvent<HTMLInputElement>) => void;
  children?: ReactNode;
  checked:boolean;
  type:string;
};

const RadioButton:React.FC<RadioButtonProps> = ({ type, name, checked, onChange, children, value }) => {
  return (
    <RadioWrapper>
      <RadioInput
        type={type}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <CustomRadioButton
        checked={checked}
      >
        {checked ? <IoIosRadioButtonOn size={16} /> : <IoIosRadioButtonOff size={16} /> }
      </CustomRadioButton>
      <RadioLabel>{children}</RadioLabel>
    </RadioWrapper>
  );
};

export default RadioButton;

const RadioWrapper =styled.label`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: space-between;
  align-items: center;
  cursor: pointer;
`;
const RadioInput =styled.input`
  display: none;
`;
const CustomRadioButton = styled.span<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

const RadioLabel = styled.p`
  align-items: center;
  margin-top: 16px;
  margin-left: -4px;
  color: #333;
`